import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { PumpService } from 'src/app/services/pump.service';
import { TankService } from 'src/app/services/tank.service';
import { Pump } from 'src/app/shared/models/Pump';
import { Tank } from 'src/app/shared/models/Tank';

@Component({
  selector: 'app-pump-page',
  templateUrl: './pump-page.component.html',
  styleUrls: ['./pump-page.component.css']
})
export class PumpPageComponent implements OnInit {

  pumpForm: FormGroup;
  titulo = 'Asociar Tanque con Surtidor';
  tankId: number;
  tankList: Tank[] = [];
  selectedPump: Pump;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private pumpService: PumpService,
    private activatedRoute: ActivatedRoute,
    private tankService: TankService
  ) {
    this.pumpForm = this.initPumpForm();

  }

  ngOnInit() {
    this.initTankList();
  }

  savePump() {
    if (this.pumpForm.invalid) {
      return;
    }

    const pump: Pump = this.pumpForm.value;
    const save = this.pumpService.savePump(pump);

    save.subscribe(
      () => this.router.navigate(['/pumps']),
      (error) => {
        console.log(error);
        this.pumpForm.reset();
      }
    );
  }

  private initPumpForm(): FormGroup {
    return this.fb.group({
      tankId: [],
    });
  }


  private initTankList() {
    this.tankService.getAll().subscribe((tankList: Tank[]) => {
      this.tankList = tankList;
      this.getSelectedPump();
    });
  }

  private getSelectedPump() {
    this.pumpService.getPump().subscribe((selectedPump: Pump) => {
      if (selectedPump && selectedPump[0].tankId != undefined) {
        this.pumpForm.setValue({ tankId: selectedPump[0].tankId })
      }
    });
  }
}
